import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import Hero from "../components/shops/Hero";
import PainPoints from "../components/shops/PainPoints";
import Features from "../components/shops/Features";
import Comparison from "../components/shops/Comparison";
import Menu from "../components/shops/Menu";
import HowItWorks from "../components/shops/HowItWorks";
import Demo from "../components/shops/Demo";
import Examples from "../components/shops/Examples";
import Pricing from "../components/shops/Pricing";
import Contact from "../components/shops/Contact";
import Footer from "../components/shops/Footer";

const Shop = () => {
	const { t } = useTranslation();

	return (
		<>
			<Helmet>
				<title>{t("seo.shop.title")}</title>
				<meta name="description" content={t("seo.shop.description")} />
				<meta name="keywords" content={t("seo.shop.keywords")} />
				<link rel="canonical" href="https://applaby.com/tiendas" />

				<meta property="og:title" content={t("seo.shop.ogTitle")} />
				<meta property="og:description" content={t("seo.shop.ogDescription")} />
				<meta
					property="og:image"
					content="https://applaby.com/assets/store/tienda-preview.png"
				/>
				<meta property="og:url" content="https://applaby.com/tiendas" />
				<meta property="og:type" content="website" />

				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:title" content={t("seo.shop.twitterTitle")} />
				<meta
					name="twitter:description"
					content={t("seo.shop.twitterDescription")}
				/>
				<meta
					name="twitter:image"
					content="https://applaby.com/assets/store/tienda-preview.png"
				/>
			</Helmet>

			<Menu />
			<Hero />
			<PainPoints />
			<Features />
			<Comparison />
			<HowItWorks />
			<Demo />
			<Examples />
			<Pricing />
			<Contact />
			<Footer />
		</>
	);
};

export default Shop;
